import { Container, Reveal, RevealGroup } from '@/components/common'
import { ceptModel } from '@/constants/cept-model'

export const CeptModel = () => {
  return (
    <section className="bg-white py-24 text-ibon-dark lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Outcomes that <span className="text-ibon-dark/30">transform.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-text-muted">
              The CEPT Model reflects the outcomes we seek to achieve through our programmes,
              partnerships, and initiatives, and how we use entrepreneurship to create lasting
              change.
            </p>
          </Reveal>
        </div>

        <RevealGroup className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {ceptModel.map(({ key, letter, title, description, Icon }) => (
            <article
              key={key}
              className="group relative flex flex-col overflow-hidden border border-border bg-surface p-8 transition-colors hover:border-ibon-sky lg:p-10"
            >
              <span className="pointer-events-none absolute -right-4 -top-8 text-[9rem] font-bold leading-none text-ibon-dark/5 transition-colors duration-300 group-hover:text-ibon-sky/10">
                {letter}
              </span>
              <Icon className="relative text-4xl text-ibon-sky" />
              <h3 className="relative mt-8 text-2xl font-bold tracking-tight text-ibon-dark">
                {title}
              </h3>
              <p className="relative mt-5 text-base leading-relaxed text-text-muted">
                {description}
              </p>
            </article>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
